import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowForward = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 12,
	viewBox: "0 0 16 12",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.4649 0.290143L15.5277 4.94829C16.1573 5.52858 16.1573 6.47192 15.5287 7.05121L10.4649 11.7094C10.2547 11.9028 9.97868 12 9.70268 12C9.42669 12 9.1507 11.9028 8.94047 11.7094C8.51893 11.3215 8.51893 10.6946 8.94047 10.3068L12.572 6.964L1.0781 6.96471C0.482989 6.96471 0 6.52131 0 5.97277C0 5.42423 0.482989 4.98083 1.0781 4.98083L12.514 4.98L8.94047 1.69275C8.51893 1.30589 8.51893 0.677991 8.94047 0.290143C9.362 -0.0967142 10.0434 -0.0967142 10.4649 0.290143Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgArrowForward);
export { ForwardRef as ReactComponent };
